module.exports = __webpack_public_path__ + "fonts/GalanoGrotesque-Medium.5ac478b.woff2";